import { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import { supabase } from '../services/supabase';

const CUSTOMER_FIELDS = `
  id, name, nickname,
  billing_address, billing_city, billing_state, billing_zip,
  billing_contact_name, billing_contact_email, billing_contact_phone,
  shipping_address, shipping_city, shipping_state, shipping_zip,
  shipping_contact_name, shipping_contact_email, shipping_contact_phone
`;

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '34px',
    borderRadius: '2px',
    borderColor: state.isFocused ? '#94a3b8' : '#e2e8f0',
    boxShadow: state.isFocused ? '0 0 0 1px #94a3b8' : 'none',
    fontSize: '0.875rem',
    '&:hover': { borderColor: '#94a3b8' },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '0.875rem',
    backgroundColor: state.isSelected ? '#334155' : state.isFocused ? '#f1f5f9' : 'white',
    color: state.isSelected ? 'white' : '#0f172a',
    cursor: 'pointer',
  }),
  menu: (base) => ({ ...base, fontSize: '0.875rem', borderRadius: '2px', zIndex: 50 }),
  menuPortal: (base) => ({ ...base, zIndex: 50 }),
};

export default function CustomerPicker({
  value,
  onChange,
  placeholder = 'Select customer…',
  isDisabled = false,
  className = '',
}) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('customers')
      .select(CUSTOMER_FIELDS)
      .order('name');
    if (!error) setCustomers(data || []);
    setLoading(false);
  }, []);

  useEffect(() => { fetchCustomers(); }, [fetchCustomers]);

  const options = customers.map((c) => ({
    value: c.id,
    label: c.nickname ? `${c.name} (${c.nickname})` : c.name,
    customer: c,
  }));

  const selected = value != null
    ? options.find((o) => o.value === value) || null
    : null;

  return (
    <div className={className}>
      <Select
        value={selected}
        onChange={(opt) => onChange?.(opt?.value ?? null, opt?.customer ?? null)}
        options={options}
        isLoading={loading}
        isClearable
        placeholder={placeholder}
        isDisabled={isDisabled}
        styles={selectStyles}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      />
    </div>
  );
}
